import type { HighlightAdapter } from '../highlight-adapter.js'
import type { SelectableFeatureRef, CotrexTrailRef } from '../selectable-feature-ref.js'
import { cotrexLayerService } from '../../cotrex/cotrex-layer-service.js'

export class CotrexAdapter implements HighlightAdapter {
  readonly sources = ['cotrex-trail', 'cotrex-trailhead']

  applyHighlights(refs: SelectableFeatureRef[]): void {
    const trails = refs.filter((r): r is CotrexTrailRef => r.source === 'cotrex-trail')
    cotrexLayerService.highlightTrails(trails)
  }

  clearHighlights(): void {
    cotrexLayerService.clearHighlight()
  }
}
